import script from "./BuscadorContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./BuscadorContainer.vue?vue&type=script&setup=true&lang=js"

import "./BuscadorContainer.vue?vue&type=style&index=0&id=5237351a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5237351a"]])

export default __exports__